import type { SigninRedirectArgs, UserManager } from "oidc-client-ts";
import { userManager } from "./EnvUtils";

/**
 * Redirects to the identity server unless the page is hidden. Nobody is there
 * to complete a sign-in on a hidden page; the `visibilitychange` handler in
 * `index.tsx` signs in on return if the session is missing or expired by then.
 *
 * Components pass `via: auth` from `useAuth()` so react-oidc-context tracks
 * the navigation in `activeNavigator` and `error`.
 */
export const interactiveSignin = ({
  via = userManager,
  ...args
}: SigninRedirectArgs & {
  via?: Pick<UserManager, "signinRedirect">;
} = {}) => {
  if (document.visibilityState === "hidden") {
    return Promise.resolve();
  }
  return via.signinRedirect(args);
};
